<template>
  <div class="container" v-if="visible">
    <div class="banner-container">
      <img :src="lotteryDetail.actTitleImg" alt="">
    </div>
    <div class="lottery-container">
      <lottery
        :phone="phone"
        :user-name="null"
        :appType="appType"
        :title-image="lotteryDetail.bttTitleImg"
        :background-image="lotteryDetail.bttBgImg"
        :list="lotteryDetail.labg"
        :actiBigturntableId="lotteryDetail.id"
        :acti-large-post-id="null"
      />
    </div>
    <div class="bottom-container">
      <img :src="lotteryDetail.actBotImg" alt="">
    </div>
  </div>
</template>

<script>
import Lottery from '@/components/Lottery.vue'
import { getLotteryConfig } from '@/api'
import { Dialog } from 'vant'

export default {
  name: 'index',
  components: {
    Lottery
  },
  data() {
    return {
      phone: '',
      appType: '',
      lotteryDetail: {
        actTitleImg: '',
        actBotImg: ''
      },
      visible: true
    }
  },
  created() {
    const { id, phone } = this.$route.query
    if (id) {
      getLotteryConfig({ id })
        .then((res) => {
          this.lotteryDetail = res.data
        })
    } else {
      Dialog.alert({
        title: '警告',
        message: '需要活动id'
      })
        .then(() => {
          this.visible = false
        })
    }
    if (phone) {
      this.phone = phone
    } else {
      Dialog.alert({
        title: '警告',
        message: '需要传入手机号'
      })
      .then(() => {
        this.visible = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
img{
  display: block;
  width: 100%;
}
</style>
